module.exports = __webpack_public_path__ + "static/messenger-vanish-mode-d45897791305a2ff72711d65f86f0197.png";